export const fields = ["هندسة", "طب و تمريض", "مناديب", "أمن و سلامة", "سكرتارية", "رياضة", "وظائف إدارية", "اخرى"];

export const areas = [
  "عمل عن بعد",
  "مدينة الكويت",
  "دسمان",
  "شرق",
  "الصوابر",
  "المرقاب",
  "القبلة",
  "الصالحية",
  "الوطية",
  "بنيد القار",
  "كيفان",
  "الدوحة",
  "الدسمة",
  "الدعية",
  "المنصورية",
  "عبدالله السالم",
  "النزهة",
  "الفيحاء",
  "الشامية",
  "الروضة",
  "العديلية",
  "الخالدية",
  "القادسية",
  "قرطبة",
  "السرة",
  "اليرموك",
  "الشويخ",
  "الري",
  "غرناطة",
  "الصليبيخات",
  "النهضة",
  "جابر الأحمد",
  "القيروان",
  "شمال غرب الصليبيخات",
  "الفنطاس",
  "العقيلة",
  "الظهر",
  "المقوع",
  "المهبولة",
  "الرقة",
  "هدية",
  "أبو حليفة",
  "الصباحية",
  "المنقف",
  "الفحيحيل",
  "الأحمدي",
  "الوفرة",
  "الزور",
  "ميناء عبدالله",
  "الوفرة الزراعية",
  "بنيدر",
  "الجليعة",
  "الضباعية",
  "جابر العلي",
  "فهد الأحمد",
  "الشعيبة",
  "واره",
  "صباح الأحمد",
  "النويصيب",
  "الخيران",
  "الخيران السكنية",
  "أم الهيمان",
  "صباح الأحمد البحرية",
  "أبرق خيطان",
  "الأندلس",
  "إشبيلية",
  "جليب الشيوخ",
  "خيطان",
  "العمرية",
  "العارضية",
  "العباسية",
  "الفردوس",
  "الفروانية",
  "الحساوي",
  "الشدادية",
  "الرابية",
  "الرحاب",
  "الرقعي",
  "صباح الناصر",
  "عبدالله المبارك",
  "الضجيج",
  "الصليبية",
  "أمغرة",
  "النعيم",
  "القصر",
  "الواحة",
  "تيماء",
  "النسيم",
  "العيون",
  "القيصرية",
  "العبدلي",
  "الجهراء",
  "كاظمة",
  "سعد العبدالله",
  "السالمي",
  "المطلاع",
  "الحرير",
  "كبد",
  "الروضتين",
  "الصبية",
  "حولي",
  "الشعب",
  "السالمية",
  "الرميثية",
  "الجابرية",
  "مشرف",
  "بيان",
  "البدع",
  "النقرة",
  "ميدان حولي",
  "مبارك العبدالله الجابر",
  "سلوى",
  "جنوب السرة",
  "الزهراء",
  "الصديق",
  "حطين",
  "السلام",
  "الشهداء",
  "العدان",
  "القصور",
  "القرين",
  "صباح السالم",
  "المسيلة",
  "المسايل",
  "أبو فطيرة",
  "أبو الحصانية",
  "صبحان",
  "الفنيطيس",
  "مبارك الكبير",
];

export const devices = {
  mobile: "(max-width: 600px)",
  tablet: "(max-width: 800px)",
};
